import { render, staticRenderFns } from "./CourseSearch.vue?vue&type=template&id=1069ff26"
import script from "./CourseSearch.vue?vue&type=script&lang=js"
export * from "./CourseSearch.vue?vue&type=script&lang=js"
import style0 from "./CourseSearch.vue?vue&type=style&index=0&id=1069ff26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports